<template>

  <div id="roleTemplateManager">
    <div class="dialog-content">
      
      <!-- CONTEXTS -->
      <div v-if="editing" class="context">To edit a role template, select the title field and select or deselect the specific role permissions below.</div>
      <div v-else class="context">To add a new role template, enter a title, select an access level, and select which permissions this role template will allow.</div>
      <v-form>
        <v-text-field ref="inputTitle" :validate-on-blur="$refs.inputTitle && $refs.inputTitle.valid" :rules="rules.title" label="Title" prepend-icon="mdi-format-title" v-model.trim="role.title" :disabled="editing"></v-text-field>
      </v-form>

      <div style="margin-top: 16px;" class="title-area">Permissions</div>
      <div class="section">

        <div class="subtitle" style="margin-bottom: 16px;">Access Level</div>

        <div v-if="editing" class="context" style="margin-bottom: 0;">Access levels define how much access a user has on your company. Access levels cannot be modified once a role template has been created.</div>
        <div v-else class="context" style="margin-bottom: 0px">Access levels define how much access a user has on your company. Access levels cannot be modified once a role template has been created.
          <br><br>
          Unit Specific: Permissions only allow access within the unit they are assigned to.
          <br><br>
          Property Specific: Permissions only allow access for the items within the property they are assigned to.
          <br><br>
          All Properties: Permissions apply to all properties.
        </div>

        <v-select ref="selectAccessLevel" :items="accessLevels" :rules="rules.accessLevel" v-model="role.accessLevel" label="Select an Access Level" :disabled="editing" single-line bottom>
        </v-select>

        <!-- ROLE PERMISSIONS -->
        <vo-role-permissions ref="rolePermissions" class="role-permissions" v-show="role.accessLevel" :accessLevel="role.accessLevel"></vo-role-permissions>
      </div>

    </div>
    <div class="dialog-footer">
      <v-btn class="button" :disabled="lockout.on" flat color="info" @click="routeRemoveQueries(['dialog', 'dialogAction'])">Cancel</v-btn>
      <v-btn class="button" :loading="lockout.on" flat color="primary" @click="editing ? save() : create()">{{ editing ? 'Save' : 'Create' }}</v-btn>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        
        editing: null,
        
        role: {
          accessLevel: null,
          permissions: {},
          title: ''
        },
      
        errors: {
          title: false
        },

        rules: {
          title: [
            function (e) {
              return !window.regex.title.test(e) ? 'Please enter a title.' : true;
            }
          ],
          accessLevel: [
            function (e) {
              return !e ? 'Please select an access level.' : true; 
            }
          ]
        },
                
        accessLevel: null,
        accessLevels: [
          {
            text: 'Unit Specific',
            value: 1
          },
          {
            text: 'Property Specific',
            value: 2
          },
          {
            text: 'All Properties',
            value: 3
          }
        ],

      }
    },  
    props: {
      dialogComponent: {
        
      },
      lockout: {

      }
    },
    methods: {
      
      create () {
        this.lockout.on = true;
        var valid = this.validate();
        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout.on = false;
          return;
        }

        var role = {
          requires: this.getAccessLevel(this.role.accessLevel),
          permissions: this.$refs.rolePermissions.value,
          title: this.role.title
        };

        this.$store.dispatch('createRoleTemplate', {
          company: this.$store.getters.company._id,
          role: role
        })
        .then(data => {
          AppData.app.pages.roleTemplates.list.addItem(data._id, {unshift: true});
    
          this.routeAddQuery('details', data._id);
          this.routeRemoveQuery('dialog');

          // Reinit Filters to reflect changes
          window.AppData.initFilters();
    
          Toast.show('Role Template created.', 'success');
          this.lockout.on = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.lockout.on = false;
        });
      },

      save () {  
        this.validate();

        var role = {
          _id: this.role._id,
          permissions: this.$refs.rolePermissions.value 
        };

        this.$store.dispatch('updateRoleTemplate', {
          role: role
        })
        .then(data => {
          this.routeRemoveQuery('dialog');

          // Reinit Filters to reflect changes
          window.AppData.initFilters();
    
          Toast.show('Role Template updated.', 'success');
          this.lockout.on = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.lockout.on = false;
        })
      },

      validate () {
        this.$refs.inputTitle.validate(true);
        this.$refs.selectAccessLevel.validate(true);
        return (this.$refs.inputTitle.valid && this.$refs.selectAccessLevel.valid);        
      },

      getAccessLevel (e) {
        var requires = {};
        if (e <= 2) requires.property = true; 
        if (e <= 1) requires.unit = true;
        return requires; 
      }

    },
    
    watch: {
      'role.permissions' () {
        if (this.role && this.role.permissions) this.$refs.rolePermissions.init(this.role.permissions);
      }
    },

    created () {
      this.editing = this.$route.query.dialogAction && this.$route.query.dialogAction === 'edit';
      if (this.editing) {
        var selected = this.$store.getters.roleTemplate(this.app.pages.roleTemplates.selected);
        this.role = {
          _id: selected._id,
          title: selected.title,
          permissions: selected.permissions,
          accessLevel: selected.requires ? (selected.requires.unit ? 1 : 2) : 3
        }
      }

      this.title = this.editing ? 'Edit Role Template' : 'Create Role Template';
      this.$emit('title', this.title);
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #roleTemplateManager {
    position: relative;

    .dialog-content {
      padding: 24px;
    }

    .section {
      padding: 16px;
      box-sizing: border-box;

      .subtitle {
        @include fontPrimary500();
        @include title();
        font-size: 12px;
        margin: 16px 0 0;
      }

      .access-level {
        margin: 0 0 24px 16px;
        color: $black54;
      }

    }

  }

</style>


// WEBPACK FOOTER //
// src/components/RoleTemplateManage.vue